import { createContext } from 'react';
var ModalsContext = createContext(null);
ModalsContext.displayName = "@mantine/modals/ModalsContext";
export { ModalsContext };